interface Country {
  name: string;
  flag: string;
  code: string;
}

export const countries: Country[] = [
  { name: 'Brasil', flag: '🇧🇷', code: '+55' },
  { name: 'África do Sul', flag: '🇿🇦', code: '+27' },
  { name: 'Alemanha', flag: '🇩🇪', code: '+49' },
  { name: 'Arábia Saudita', flag: '🇸🇦', code: '+966' },
  { name: 'Argentina', flag: '🇦🇷', code: '+54' },
  { name: 'Austrália', flag: '🇦🇺', code: '+61' },
  { name: 'Bélgica', flag: '🇧🇪', code: '+32' },
  { name: 'Canadá', flag: '🇨🇦', code: '+1' },
  { name: 'Chile', flag: '🇨🇱', code: '+56' },
  { name: 'China', flag: '🇨🇳', code: '+86' },
  { name: 'Colômbia', flag: '🇨🇴', code: '+57' },
  { name: 'Coreia do Sul', flag: '🇰🇷', code: '+82' },
  { name: 'Dinamarca', flag: '🇩🇰', code: '+45' },
  { name: 'Egito', flag: '🇪🇬', code: '+20' },
  { name: 'Emirados Árabes', flag: '🇦🇪', code: '+971' },
  { name: 'Espanha', flag: '🇪🇸', code: '+34' },
  { name: 'Estados Unidos', flag: '🇺🇸', code: '+1' },
  { name: 'Finlândia', flag: '🇫🇮', code: '+358' },
  { name: 'França', flag: '🇫🇷', code: '+33' },
  { name: 'Holanda', flag: '🇳🇱', code: '+31' },
  { name: 'Índia', flag: '🇮🇳', code: '+91' },
  { name: 'Irlanda', flag: '🇮🇪', code: '+353' },
  { name: 'Israel', flag: '🇮🇱', code: '+972' },
  { name: 'Itália', flag: '🇮🇹', code: '+39' },
  { name: 'Japão', flag: '🇯🇵', code: '+81' },
  { name: 'México', flag: '🇲🇽', code: '+52' },
  { name: 'Noruega', flag: '🇳🇴', code: '+47' },
  { name: 'Nova Zelândia', flag: '🇳🇿', code: '+64' },
  { name: 'Paraguai', flag: '🇵🇾', code: '+595' },
  { name: 'Peru', flag: '🇵🇪', code: '+51' },
  { name: 'Polônia', flag: '🇵🇱', code: '+48' },
  { name: 'Portugal', flag: '🇵🇹', code: '+351' },
  { name: 'Reino Unido', flag: '🇬🇧', code: '+44' },
  { name: 'Rússia', flag: '🇷🇺', code: '+7' },
  { name: 'Suécia', flag: '🇸🇪', code: '+46' },
  { name: 'Suíça', flag: '🇨🇭', code: '+41' },
  { name: 'Turquia', flag: '🇹🇷', code: '+90' },
  { name: 'Uruguai', flag: '🇺🇾', code: '+598' },
];
